import Vue from 'vue'
import App from './App.vue'
import MetaInfo from 'vue-meta-info'
if (window.location.href.indexOf('localhost:3001') === -1) {
  require('./utils/zhuge')
}
import Toast from '../../../components/toast/index'
Vue.use(Toast)
import store from './store/index'
import { mai } from '../../../utils/buried'
Vue.prototype.$mai = mai
Vue.config.productionTip = false
for (const i in process.env) {
  const a = i.substr(13)
  window[a] = process.env[i]
}
new Vue({
  store,
  render: (h) => h(App),
  mounted: () => {
    document.dispatchEvent(new Event('custom-render-trigger'))
  }
}).$mount('#app')
